<template>
    <div v-loading="loading">
        <pre style="padding: 10px; font-size:16px; font-weight: 400; background-color:#EEEEEE;">{{ content }}</pre>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
    export default {
        name:'Statement',
        data() {
            return {
                content:'',
                loading: true,
            }
        },
        mounted() {
            this.ReadOneCompete()
        },
        methods: {
            ReadOneCompete() {
                const vue = this
                const route = this.$route
                $.ajax({
                    url: Url.rOneCompeteUrl,
                    type:'post',
                    data: {
                        id: route.params.id
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.content = JSON.parse(resp.compete).content
                            vue.loading = false
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>